import script from "./Textarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./Textarea.vue?vue&type=script&setup=true&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=fb60aa3e&scoped=true&lang=css"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb60aa3e"]])

export default __exports__